/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { Dispatch } from '../redux';
import { NotaryAPI } from '../api/notary/types';

import UserResponse = NotaryAPI.UserResponse;

export function setCurrentUser(user: UserResponse) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_CURRENT_USER',
      payload: {
        id: user.id,
        principalId: user.principalId,
        permissions: user.permissions,
        fullName: `${user.firstName} ${user.lastName}`,
      },
    });
  };
}
